import React from 'react';
import { createPortal } from 'react-dom';
import { CATEGORY_CONFIG, LeaderboardStandingBoard } from 'types/interfaces/leaderboard';
import { standingBarWidth, standingGapLine } from '../../utils/leaderboardDisplay';
import { GapText } from '../YourStandingPanel/YourStandingPanel';
import './MobileRankBar.css';

interface MobileRankBarProps {
  board: LeaderboardStandingBoard | null;
}

/** Height of the bar; the page pads its list by the same amount so the last row is never covered. */
export const MOBILE_RANK_BAR_HEIGHT = 72;

/**
 * Mobile only: the active board's rank, gap line and animated bar, fixed to
 * the bottom of the viewport. Portalled to document.body so no ancestor with a
 * transform or filter becomes its containing block.
 */
const MobileRankBar: React.FC<MobileRankBarProps> = ({ board }) => {
  if (!board) return null;
  const isNewMembers = board.category === 'new_members';
  return createPortal(
    <div className="mobile-rank-bar" style={{ height: MOBILE_RANK_BAR_HEIGHT }} role="status">
      <div className="mobile-rank-bar__head">
        <span className="mobile-rank-bar__label">{CATEGORY_CONFIG[board.category].label}</span>
        {!isNewMembers && (
          <span className="mobile-rank-bar__rank">{board.rank === null ? '–' : `#${board.rank}`}</span>
        )}
      </div>
      {!isNewMembers && (
        <span className="mobile-rank-bar__bar" aria-hidden="true">
          <span className="mobile-rank-bar__fill" style={{ width: `${standingBarWidth(board)}%` }} />
        </span>
      )}
      <span className="mobile-rank-bar__gap">
        <GapText line={standingGapLine(board)} />
      </span>
    </div>,
    document.body
  );
};

export default MobileRankBar;
